// import Vue from "vue";
import axios from '../helpers/axios'

export default {
  namespaced: true,

  state: {
    horariosDiasDisponibles:[],  
    datosSesionAprendizaje:{},

    activarModal: false,
    periodo: null,
    id_docente: null,
  },
  getters: {
    getConfiguracion: (state) => {
      return {
        id_docente: state.id_docente,
        periodo: state.periodo,
        activarModal: state.activarModal,
      };
    },
  },
  mutations: {
    setHorariosDiasDisponibles(state, array) {
      // state.horariosDiasDisponibles = payload;
      state.horariosDiasDisponibles = (array);
    },
    setDataSesionAprendizaje(state, object) {
        state.datosSesionAprendizaje = object;
    },

    setCloseCalendario(state) {
      state.activarModal = false;
    },

    setActivarCalendario(state, datos) {
      (state.activarModal = true),
        (state.periodo =
          datos.periodo == null || datos.periodo == "" ? null : datos.periodo);
      state.id_docente =
        datos.id_docente == null || datos.id_docente == ""
          ? null
          : datos.id_docente;
    },
  },
  actions: {

    async obtenerHorariosDocente({commit},{id_personal,id_seccion, id_curso}) { 

      const arrayDiasHabiles = [];

      try {
        let { data } = await axios.get(`/academico/progDocente/getHorariosDoc/${id_personal}/${id_seccion}/${id_curso}`);

        console.log(data);

        data.forEach(element => {
          arrayDiasHabiles.push(element.orden_dia)
        });

        commit("setHorariosDiasDisponibles", arrayDiasHabiles);
     
      } catch (error) {

        console.log(error);

      }

    },
  },
};
